import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import PickupLocationsPage from './PickupLocationsPage';
import './PickupLocationsPage.less';

export const prefix = 'bm-p-pickup-locations';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: PickupLocationsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
